var $export=require("./_export");$export($export.S,"Object",{"create":require("./_object-create")});